// Libraries
import { VictoryBar, VictoryTooltip } from 'victory';
// Types
import { RatingKeys } from '@globalTypes/index';
import { RenderBarsProps } from './BarChart.types';
// Utils
import { RatingList } from '@constants/index';
//Components
import { BarTooltipWrapper } from '@molecules/index';

/**
 * Renders VictoryBar components based on the provided data.
 *
 * @function
 * @param {ChartBarData} barData - The data for the bar chart.
 * @returns {ReactElement[]} An array of ReactElement components representing the bars in the
 * bar chart.
 *
 * Important Note: This implementation relies on the Victory library, which does not
 * support creating this
 * component as a separate module due to potential injection vulnerabilities. Please avoid
 * using this
 * function where possible.
 *
 * For more information, refer to the documentation:
 * https://formidable.com/open-source/victory/docs
 */
export const renderBars = ({ barData }: RenderBarsProps) => {
  return RatingList.map((key) => {
    return (
      <VictoryBar
        labelComponent={<VictoryTooltip flyoutComponent={<BarTooltipWrapper />} />}
        key={key}
        data={barData[key as RatingKeys]}
        x='type'
        y='quantity'
        //We are using `labels={() => ''}` to disable the labels for the VictoryBar components.
        labels={() => ''}
      />
    );
  });
};
